import Vue from 'vue'

Vue.directive('focus', {
  inserted(el) {
    el.select()
  }
})

Vue.directive('modalFocus', {
  inserted(el) {
    $(el)
      .closest('.modal').on('show.bs.modal', a => {
        setTimeout(() => {
          el.select();
        }, 500);
      })
  }
})

Vue.directive('date', {
  bind(el) {
    $(el).datepicker({
      format: 'yyyy/mm/dd'
    });
  }
})
